import React from 'react';
import './NavigationBar.scss';
import { withRouter } from 'react-router-dom';

export default withRouter(function NavigationBar({ history, backTo }) {
  return (
    <div
      className="NavigationBar__back-button"
      onClick={() => (backTo ? history.replace(backTo) : history.goBack())}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
      >
        <circle cx="16" cy="16" r="16" fill="#000" fillOpacity="0.3"></circle>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M20.291 9.38l-.65-.76L11 16l8.641 7.38.65-.76L12.54 16l7.751-6.62z"
          clipRule="evenodd"
        ></path>
      </svg>
    </div>
  );
});
